<template>
    <div id="citationEdit">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Update Citation</div>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <router-link class="btn btn-secondary" v-bind:to="{name: 'CitationDetailList',params:{batch:batch}}" > <i class="fp-back"> </i> Back</router-link>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content claim-collection">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CitationEditForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id"
                                                label="text" :filterable="false" :options="customerArr"
                                                @search="onSearchCustomer"
                                                placeholder="Select Customer" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="source">Toll Source:</label>
                                        <input type="text" class="form-control text-right" v-model="toll_source" id="toll_source" placeholder="Enter Source" name="toll_source" >
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="id">Toll ID:</label>
                                        <input type="text" class="form-control text-right" v-model="toll_id" id="toll_id" placeholder="Enter Toll ID" name="toll_id" @keypress="isIntegerCheck($event)">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Asset:</label>
                                        <v-select v-model="vehicle_id" name="vehicle_id"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchVehicle"
                                            placeholder="Select Asset" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vehicle_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="cost_claimed">Toll Amount:</label>
                                        <input type="text" class="form-control text-right" v-model="toll_amount" id="toll_amount" placeholder="Enter Toll Charge" name="toll_amount" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{toll_amount_error_msg}}</div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="cost_claimed">Toll Fee:</label>
                                        <input type="text" class="form-control text-right" v-model="toll_fee" id="toll_fee" placeholder="Enter Fee" name="toll_fee" @keypress="isIntegerCheck($event)">
                                    </div> -->

                                    <div class="col form-group">
                                        <label class="control-label require" for="claim_date">Toll Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="toll_date" name="toll_date" v-model="toll_date" :config="optionsDate"></date-picker>
                                            <label for="toll_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ toll_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="location">Toll Violation Location:</label>
                                        <input type="text" class="form-control text-right" v-model="toll_vloc" id="toll_vloc" placeholder="Enter Location" name="toll_vloc">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="agency">Toll Violation Agency:</label>
                                        <input type="text" class="form-control text-right" v-model="toll_v_agency" id="toll_v_agency" placeholder="Enter Agency" name="toll_v_agency">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="plate">Toll Violation Plate:</label>
                                        <input type="text" class="form-control text-right" v-model="toll_vplate" id="toll_vplate" placeholder="Enter Plate" name="toll_vplate">
                                    </div>

                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createCollectionBtn" class="btn btn-primary" v-on:click.prevent="createCitation">
                                    <i class="fp-reload"> </i>  Update
                                    </button>

                                    <button type="submit" id="cancelCollectionBtn" class="btn btn-tertiary" v-on:click.prevent="BackCitationList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ClaimCollectionList",
        metaInfo() {
            return {title: "Citation Update | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            loading:false,
            canUpdateProgram:false,
            canAddProgram:false,
            optionsDate: {
                format: 'MM/DD/YYYY HH:mm:ss',
                useCurrent: false,
            },
            toll_amount:'',
            toll_amount_error_msg:'',
            toll_date:'',
            toll_date_error_msg:'',
            toll_fee:'',
            vehicle_id:'',
            vehicle_error_msg:'',
            customer_id:'',
            customer_error_msg:'',
            batch:'',
            customerArr:[],
            vehicleArr:[],
            toll_source: '',
            toll_id:'',
            toll_vloc:'',
            toll_v_agency:'',
            toll_vplate:'',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'update_citation') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]){
              self.loadCitationData(segments[3]);
            }

        },
        methods: {
            BackCitationList:function(){
                var self = this;
                self.$router.push("/citation-detail/list/"+self.batch)
            },
            onSearchCustomer(search, loading) {
                var self = this;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'customer', '');
                }
            },
            onSearchVehicle(search, loading) {
                var self = this;
                if (search.length > 3) {

                    loading(true);
                    self.searchField(loading, search, 'vehicle', '');
                }
            },

            loadCitationData:function(citationId){
                var self = this;

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/citation-data/fetch/"+citationId,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.content.customer_id && data.content.customer_id != null){

                            self.customer_id = {text:data.content.customer_number+' | '+data.content.name,value:data.content.customer_id};

                        }
                        if (data.content.vehicle_id && data.content.vehicle_id != null){

                            self.vehicle_id = {text:data.content.vehicle_name+' | '+data.content.unit_no,value:data.content.vehicle_id};

                        }
                        self.toll_date = data.content.toll_datetime;
                        self.toll_amount = data.content.toll_charge;
                        self.toll_fee = data.content.toll_fee;
                        self.batch = data.content.batch;
                        self.toll_source = data.content.source;
                        self.toll_id = data.content.toll_id;
                        self.toll_vloc = data.content.toll_violation_location;
                        self.toll_v_agency = data.content.toll_voilation_agency;
                        self.toll_vplate = data.content.toll_voilation_plate;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
                    }
                });
            },

            createCitation() {

                var self = this;
                var error = false;

                var path = window.location.pathname;
                var segments = path.split("/");
                self.toll_date_error_msg = "";
                self.vehicle_error_msg = "";
                self.customer_error_msg = "";
                self.toll_amount_error_msg = '';

                if (self.customer_id == null || !self.customer_id.value){
                    self.customer_error_msg = "Customer Required";
                    error = true;
                }

                if (self.vehicle_id == null || !self.vehicle_id.value){
                    self.vehicle_error_msg = "Asset Required";
                    error = true;
                }
                if (!self.toll_amount || self.toll_amount == null || self.toll_amount == "") {
                    self.toll_amount_error_msg = "Toll Amount is required.";
                    error = true;
                }

                if (!self.toll_date || self.toll_date == null || self.toll_date == "") {
                    self.toll_date_error_msg = "Toll Date is required.";
                    error = true;
                }

                if (!error) {

                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");

                    var fields = $('#CitationEditForm').serializeArray();
//alert(self.toll_source);
                    fields.push({name: "customer_id", value: self.customer_id.value});
                    fields.push({name: "vehicle_id", value: self.vehicle_id.value});
                    fields.push({name: "toll_source", value: self.toll_source});
                    fields.push({name: "toll_id", value: self.toll_id});
                    fields.push({name: "toll_vloc", value: self.toll_vloc});
                    fields.push({name: "toll_v_agency", value: self.toll_v_agency});
                    fields.push({name: "toll_vplate", value: self.toll_vplate});

                    if (segments[3]){

                        fields.push({name: "id", value: segments[3]});

                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/citation/update",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                            if (data.status == "success") {
                                self.$router.push("/citation-detail/list/"+data.content.batch);

                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;

                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");

                                    self.$router.push("/");
                                }
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    });
                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/CitationEdit.vue